// Components/Common/ImageProtection/ImageProtection.js
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ImageProtection = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Check if we're on the admin page
    const isAdminPage = location.pathname === "/" || location.pathname === "";

    // If we're on admin page - don't activate protections
    if (isAdminPage) {
      return; // Exit the function without adding listeners
    }

    // === From here protections are active only on non-admin pages ===

    // Prevent right click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent dragging
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent text selection
    const handleSelectStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent copying
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent saving image with keyboard (Ctrl+S)
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === "s" || e.key === "S")) {
        e.preventDefault();
        return false;
      }
    };

    // Add listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("dragstart", handleDragStart);
    document.addEventListener("selectstart", handleSelectStart);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup when removing component
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("selectstart", handleSelectStart);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [location.pathname]); // Listen for path changes

  return <>{children}</>;
};

// Protected image component - remains as is
export const ProtectedImage = ({ src, alt, className, style, ...props }) => {
  const handleError = (e) => {
    e.preventDefault();
  };

  return (
    <div
      className={`protected-image-wrapper ${className || ""}`}
      style={{
        position: "relative",
        display: "inline-block",
        ...style,
      }}
    >
      <img
        src={src}
        alt={alt}
        draggable="false"
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        onError={handleError}
        style={{
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          WebkitTouchCallout: "none",
          WebkitUserDrag: "none",
          pointerEvents: "none",
        }}
        {...props}
      />
      {/* Transparent protection layer */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
          backgroundColor: "transparent",
        }}
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
      />
    </div>
  );
};

export default ImageProtection;
